export function routeRegistryKey(path) {
  return isLegacyMenuRoute(path) ? '/legacy-menu' : path
}

export function isLegacyMenuRoute(path) {
  return String(path || '').indexOf('/legacy-menu/') === 0
}

// Some pages are deliberately hidden from the side menu because they need a
// project or service-item context supplied by their parent page.  They are
// still part of the same business workflow, rather than legacy-menu fallbacks.
// Keep this relationship explicit so the navigation guard does not reject a
// legitimate in-app transition after dynamic routes have been restored.
const internalWorkflowParents = {
  '/project/members': ['/project/list'],
  '/project/interview-config': ['/project/list'],
  '/project-evaluations/material': ['/project-evaluations'],
  '/service-items': ['/project/list'],
  '/documents': ['/project/list', '/service-items'],
  '/process-items': ['/project/list', '/service-items'],
  '/report-workbench': ['/project/list', '/service-items'],
  '/cameras': ['/rooms'],
  '/system/role-authorization': ['/system/roles']
}

const internalWorkflowActions = {
  '/project/members': '3007',
  '/project/interview-config': '3014',
  '/project-evaluations/material': '3502',
  '/cameras': '3805',
  '/system/role-authorization': '1104'
}

export function flattenMenuPaths(menus) {
  const paths = []
  ;(Array.isArray(menus) ? menus : []).forEach(menu => {
    if (!menu) return
    if (menu.path) {
      paths.push(menu.path)
    }
    paths.push(...flattenMenuPaths(menu.children))
  })
  return paths
}

export function canAccessRoute(menus, path) {
  const routeKey = routeRegistryKey(path)
  if (internalWorkflowActions[routeKey] && !hasAction(menus, internalWorkflowActions[routeKey])) {
    return false
  }
  const menuPaths = flattenMenuPaths(menus)
  if (menuPaths.some(menuPath => routeRegistryKey(menuPath) === routeKey)) {
    return true
  }
  return (internalWorkflowParents[routeKey] || []).some(parentPath =>
    menuPaths.some(menuPath => routeRegistryKey(menuPath) === parentPath)
  )
}

function hasAction(menus, moduleId) {
  const expected = String(moduleId)
  return (Array.isArray(menus) ? menus : []).some(menu => {
    if (!menu) return false
    if ((menu.actionIds || []).map(String).includes(expected)) return true
    return hasAction(menu.children, expected)
  })
}
